@if (!IsNullOrUndefined(currentItem)) {
  <div animate.enter="slide-in-bottom">
    <!-- Always-visible compact player bar (no expand/minimize) -->
    <div class="player-bar">
      <!-- Transcript: full-width strip ABOVE the controls row (~4 lines, scrolls within) -->
      @if (hasTranscript && showMiniTranscript) {
        <div class="player-bar__transcript">
          <hypecast-transcript-view
            [cues]="transcriptCues"
            [currentTimeMs]="transcriptCurrentMs"
            (seek)="onTranscriptSeek($event)">
          </hypecast-transcript-view>
        </div>
      }
      <div class="player-bar__row">
        <hypecast-audio-player (endReached)="trackListen($event)" (trackEventSent)="trackListen($event)"
          (playClicked)="trackStream($event)" (pauseClicked)="trackListen($event)"
          [hasTranscript]="hasTranscript" [transcriptOpen]="showMiniTranscript"
          (transcriptToggle)="toggleMiniTranscript()"
          [startPosition]="$safeNavigationMigration(currentItem?.startPosition)"
        [src]="$safeNavigationMigration(currentItem?.src)"></hypecast-audio-player>
      </div>
    </div>
  </div>
}
